import React from "react";
import styled, { keyframes } from "styled-components";
import { FONTS, COLORS } from "../utils/styleConstants";

const ACCENT_ORANGE = "#ff7057";

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: ${props => props.$fullHeight ? "400px" : "auto"};
  padding: ${props => props.$fullHeight ? "0" : "2rem 0"};
`;

const Spinner = styled.div`
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid ${ACCENT_ORANGE};
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
  margin-bottom: 1rem;
`;

const Message = styled.p`
  font-size: 1.1rem;
  color: #666;
  margin: 0;
  font-family: ${FONTS.PRIMARY};
`;

const LoadingIndicator = ({ message = "Cargando...", fullHeight = true }) => {
  return (
    <Container $fullHeight={fullHeight} data-testid="loading-indicator">
      <Spinner />
      <Message>{message}</Message>
    </Container>
  );
};

export default LoadingIndicator; 